export const QuestionMarkIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.93531 5.11045C3.93418 4.3439 4.14984 3.59266 4.55738 2.94343C4.96492 2.29421 5.54773 1.77345 6.23858 1.44127C6.92942 1.1091 7.70011 0.979035 8.46169 1.0661C9.22327 1.15317 9.94467 1.45382 10.5427 1.93334C11.1408 2.41287 11.591 3.05172 11.8415 3.77619C12.0919 4.50065 12.1326 5.28117 11.9584 6.0277C11.7843 6.77423 11.4026 7.4563 10.8575 7.99515C10.3123 8.534 9.62595 8.90775 8.87747 9.07328C8.63199 9.1217 8.41056 9.25311 8.25033 9.4454C8.09022 9.6377 8.00106 9.87928 7.99781 10.1295V11.3353"
				stroke="#8F9DAE"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.1875 14.1477C7.1875 13.6992 7.5511 13.3352 8 13.3352C8.4489 13.3352 8.8125 13.6992 8.8125 14.1477C8.8125 14.5965 8.44876 14.9602 8 14.9602C7.55124 14.9602 7.1875 14.5965 7.1875 14.1477Z"
				fill="#8F9DAE"
			/>
		</svg>
	);
};
